import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import UnitTypes from "services/Admin/UnitTypesService"

const UnitTypesPage = (props) => {
        return <SystemPage
                Service={UnitTypes}
                type={"UnitType"}
                meta={"Unit Types"}
                placeholder={"unit"}
                header={"Unit Types"}
                hasSub={true}
                statusType={"UnitType"}
        />

}

export default UnitTypesPage;
